import { find as _find, get as _get } from 'lodash-es';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  formControl: {
    minWidth: 195,
    margin: theme.spacing(1, 0, 2, 0),
    display: 'block',
  },
}));

type SelectOption = {
  value: string;
  label: string;
};

type Props = {
  name: string;
  label?: React.ReactNode;
  disabled?: boolean;
  touched?: boolean;
  options: SelectOption[];
  className?: string;
  helperText?: React.ReactNode;
  loading?: boolean;
  startAdornment?: React.ReactNode;
  placeholder?: string;
};

const SelectField = (props: Props) => {
  const {
    name,
    label,
    disabled,
    touched: formTouched,
    options,
    className,
    helperText,
    startAdornment,
    placeholder,
  } = props;
  const { classes, cx } = useStyles();
  const [field, meta] = useField(name);
  const touched = formTouched || meta.touched;
  const currentError = meta.error;

  return (
    <TextField
      select
      variant="outlined"
      label={label}
      name={field.name}
      id={field.name}
      value={field.value || ''}
      onChange={field.onChange}
      onBlur={field.onBlur}
      error={touched && Boolean(currentError)}
      disabled={disabled}
      helperText={(touched && currentError) || helperText}
      className={cx(classes.formControl, className)}
      slotProps={{
        inputLabel: { shrink: true },
        select: {
          displayEmpty: Boolean(placeholder),
          renderValue: (value) => {
            if (!value && placeholder) {
              return placeholder;
            }
            return _get(_find(options, ({ value }) => value === field.value), 'label');
          },
        },
        input: {
          startAdornment,
        },
      }}
    >
      {placeholder && (
        <MenuItem value="" key="placeholder">{placeholder}</MenuItem>
      )}
      {options.map((option) => (
        <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
      ))}
    </TextField>
  );
};

export default SelectField;
